import React from 'react';
import {
  Box,
  Typography,
  Checkbox,
  FormControlLabel,
  Paper,
  Alert,
  Button,
} from '@mui/material';
import {
  Visibility as ViewIcon,
  Edit as EditIcon,
} from '@mui/icons-material';

const ITOnboardingForm = ({ 
  selectedEmployee, 
  onStepComplete, 
  onStepIncomplete, 
  isCompleted,
  employeeProgress 
}) => {
  if (!selectedEmployee) {
    return (
      <Alert severity="info">
        Please select an employee first to manage their IT onboarding.
      </Alert>
    );
  }

  const handleCheckboxChange = (event) => {
    if (event.target.checked) {
      onStepComplete();
    } else {
      onStepIncomplete();
    }
  };

  const handleViewForm = () => {
    if (selectedEmployee) {
      // Open the IT onboarding form in a new tab
      window.open(`/itonboarding-form/${selectedEmployee.employeeId}`, '_blank');
    }
  };

  const handleUpdateForm = () => {
    if (selectedEmployee) {
      // Open the IT onboarding form in edit mode in a new tab
      window.open(`/itonboarding-form/${selectedEmployee.employeeId}?mode=edit`, '_blank');
    }
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        IT Onboarding Form Management
      </Typography>
      
      <Paper sx={{ p: 3, mb: 2 }}>
        <Typography variant="body1" sx={{ mb: 2 }}>
          This step involves completing the IT setup and system access requirements for the selected employee.
        </Typography>
        
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={isCompleted}
                onChange={handleCheckboxChange}
                color="primary"
              />
            }
            label="Mark as Complete"
          />
          <Box sx={{ display: 'flex', gap: 1, ml: 'auto' }}>
            <Button
              variant="outlined"
              size="small"
              startIcon={<ViewIcon />}
              onClick={handleViewForm}
            >
              View Form
            </Button>
            <Button
              variant="contained"
              size="small"
              startIcon={<EditIcon />}
              onClick={handleUpdateForm}
              sx={{ backgroundColor: '#673ab7', '&:hover': { backgroundColor: '#5e35b1' } }}
            >
              Update Form
            </Button>
          </Box>
        </Box>
        
        <Typography variant="body2" color="text.secondary">
          Click "View Form" to see the complete IT onboarding form for this employee, or "Update Form" to edit the details.
        </Typography>
      </Paper>
    </Box>
  );
};

export default ITOnboardingForm; 